// extracted by mini-css-extract-plugin
module.exports = {"layout":"siteModeChanger_layout_2wpYg","card":"siteModeChanger_card_2gvl3"};